import { Badge } from "@/components/atoms/Badge";

const WaitingBadge = () => <Badge variant="white">En attente</Badge>;

export default WaitingBadge;
